export default __webpack_public_path__ + "static/kajaki_3-e635e059da5c6678877942d8b48f9586.jpg";